import { observer } from 'mobx-react';
import React, { useMemo } from 'react';

import { useMediaQuery } from '@mui/material';

import { SEARCH_TYPE_COOKIE } from 'app/constants';
import useStores from 'hooks/use-stores';
import SearchBar from 'main/components/SearchBar';
import DrawerMenuButton from 'pages/layout/components/DrawerMenuButton';
import Logo from 'pages/layout/components/Logo';
import UpgradeLicenseButton from 'pages/layout/components/UpgradeLicenseButton';
import { getCookie } from 'utils/cookies';
import isBrowser from 'utils/is-browser';

import useStyles from './styles';

const Header = () => {
    const { classes } = useStyles();
    const { searchStore } = useStores();
    const shouldShowSearchBar = useMediaQuery('(min-width: 480px)', { defaultMatches: true });
    const shouldMenuButton = useMediaQuery('(max-width: 480px)', { defaultMatches: true });

    useMemo(() => {
        if (isBrowser()) {
            const type = getCookie(SEARCH_TYPE_COOKIE);
            if (type) {
                searchStore.setType(type);
            }
        }
    }, [searchStore]);

    return (
        <div className={classes.container}>
            <div className={classes.logoBox}>
                <Logo />
            </div>
            {shouldShowSearchBar && <SearchBar className={classes.searchBarRoot} />}
            <div className={classes.buttons}>
                <UpgradeLicenseButton />
                {shouldMenuButton && <DrawerMenuButton className={classes.menuButton} />}
            </div>
        </div>
    );
};

export default observer(Header);
